import AddIcon from '@mui/icons-material/Add';
import { Box, Button, ClickAwayListener, IconButton, Popper, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useRef, useState } from "react";
import { ReactComponent as Sectors } from "../../assets/icons/sector.svg";
import { ReactComponent as Sentence } from "../../assets/icons/sentence.svg";

const useStyles = makeStyles((theme) => ({
    card: {
        position: 'relative',
        minWidth: 275,
        width: '100%',
        height: 'fit-content',
        minHeight: 80,
        padding: '12px 16px',
        borderRadius: 8,
        backgroundColor: '#fff',
        border: `1px solid ${theme.colors.neutral['400']}`,
        boxShadow: '0px 3px 5px -1px rgba(16, 24, 40,0.2), 0px 5px 8px 0px rgba(16, 24, 40,0.14), 0px 1px 14px 0px rgba(16, 24, 40,0.12)',
        transition: 'all 300ms ease',
    },
    hoverable :{
        "&:hover": {
            background: `rgb(246, 251, 251, 1)`,
        },
    },
    icon: {
        padding: 0,
        "& > svg": {
            width: '20px !important',
            height: '20px !important'
        },
    },
    icon2: {
        padding: 0,
        paddingLeft: 4,
        paddingRight: 4,
        "& > svg": {
            width: '16px !important',
            height: '16px !important',
        },
    },
    field: {
        fontFamily: 'Inter',
        fontSize: '0.8rem',
        fontWeight: '600',
        color: '#1e293b',
    },
    customBtn: {
        width: '18ch',
        height: 36,
        borderRadius: 16,
        borderColor: theme.colors.neutral['100'],
        background: '#E0F1F1',
        color: theme.palette.primary.main,
        fontSize: '0.85rem',
        fontWeight: 'bold',
        textTransform: 'none',
        transition: 'ease-in-out 300ms',
    },
	addFieldButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: 'unset',
		padding: '8px 14px',
		backgroundColor: 'transparent',
		border: '2px dashed #cbd5e1',
		borderRadius: 10,
		color: '#64748b',
		fontSize: 14,
		fontWeight: 500,
		textTransform: 'none',
		marginTop: theme.spacing(1),
		transition: 'all 0.2s',
		'&:hover': {
		borderColor: '#1eb6a8',
		backgroundColor: '#f0fdf9',
		color: '#1eb6a8'
		}
	},
	addIcon: {
		fontSize: 16
	},
}));

const AddCustomField: React.FC<{
    onNewTag: () => void,
    onNewField: () => void,
}> = ({ onNewTag, onNewField }) => {
    const classes = useStyles();
    const [open, setOpen] = useState<boolean>(false);
    const anchorRef = useRef<HTMLButtonElement>(null);

    return (<>
        <Button className={classes.addFieldButton}
            onClick={() => setOpen(true)}
            startIcon={<AddIcon className={classes.addIcon} />}
            sx={{ width: '100%' }}
            ref={anchorRef}>{'Add Field'} </Button>
        <Popper open={open} anchorEl={anchorRef.current} placement="top" sx={{ zIndex: 1500 }}>
            <ClickAwayListener onClickAway={() => setOpen(false)}>
                <Box width="fit-content" height="fit-content">
                    <Stack className={classes.card} spacing={1} alignItems="flex-start" justifyContent="center">
                        <Stack className={classes.hoverable} spacing="4px" width="100%"
                            onClick={() => { setOpen(false); onNewTag(); }}
                            sx={{ cursor: 'pointer' }} >
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
                                <IconButton className={classes.icon} disabled>
                                    <Sectors style={{ stroke: '#64748b' }} />
                                </IconButton>
                                <Stack direction="column" alignItems="flex-start" justifyContent="center" width="100%">
                                    <Typography className={classes.field}>
                                        {'Add tags field'}
                                    </Typography>
                                    <Typography fontFamily="Inter" fontSize="0.75rem" color="#64748b" fontWeight={400}>
                                        {'Tags get assigned using AI'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                        <Stack className={classes.hoverable} spacing="4px" width="100%"
                            onClick={() => { setOpen(false); onNewField(); }}
                            sx={{ cursor: 'pointer' }} >
                            <Stack direction="row" spacing={2} alignItems="center" justifyContent="flex-start">
                                <IconButton className={classes.icon2} disabled>
                                    <Sentence style={{ stroke: '#64748b' }} />
                                </IconButton>
                                <Stack direction="column" alignItems="flex-start" justifyContent="center" width="100%">
                                    <Typography className={classes.field}>
                                        {'Add text field'}
                                    </Typography>
                                    <Typography fontFamily="Inter" fontSize="0.75rem" color="#64748b" fontWeight={400}>
                                        {'Provides flexible outputs in free text form'}
                                    </Typography>
                                </Stack>
                            </Stack>
                        </Stack>
                    </Stack>
                </Box>
            </ClickAwayListener>
        </Popper>
    </>);
}

export default AddCustomField;
